import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 220,
      sortable: true,
    },
    {
      prop: 'year',
      label: i18n.t('common_words.year'),
      align: 'center',
      sortable: true,
      minWidth: 160,
    },
    {
      prop: 'start_date',
      label: i18n.t('common_words.starting_date'),
      minWidth: 220,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'end_date',
      label: i18n.t('common_words.final_date'),
      minWidth: 220,
      align: 'center',
      sortable: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
